import React, { useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { IconButton, Tooltip } from "@mui/material";
import { FiEye, FiTrash } from "react-icons/fi";
import { CiEdit } from "react-icons/ci";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";

export const Table = ({
  data,
  fields,
  numberOfRows,
  enableTopToolBar,
  enableBottomToolBar,
  enablePagination,
  enableColumnFilters,
  enableEditing,
  enableColumnDragging,
  showPreview,
  routeLink,
  deleteFunction,
  upDatefunction,
}) => {
  const columns = useMemo(() => fields, [fields]);
  const { tableData, setTableData } = useState(() => data);
  return (
    <>
      <MaterialReactTable
        columns={columns}
        // data={(data ?? []).slice(0, numberOfRows)}
        data={Array.from(data)?.slice(0, numberOfRows)}
        getRowId={(row) => row.id}
        enableEditing={enableEditing}
        enableColumnDragging={enableColumnDragging}
        enableColumnOrdering
        enableColumnFilters={enableColumnFilters}
        enablePagination={enablePagination}
        enableBottomToolbar={enableBottomToolBar}
        enableTopToolbar={enableTopToolBar}
        muiTableBodyRowProps={{ hover: false }}
        positionActionsColumn="last"
        muiTablePaperProps={{
          sx: {
            padding: "20px",
            borderRadius: "15px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "divider",
          },
        }}
        muiTableContainerProps={{
          sx: { borderRadius: "15px" },
        }}
        muiTableHeadCellProps={{
          sx: {
            fontSize: "12px",
            fontWeight: "bold",
          },
        }}
        muiTableHeadProps={{
          sx: {
            "& tr th": {
              borderWidth: "1px",
              borderColor: "divider",
              borderStyle: "solid",
            },
          },
        }}
        muiTableBodyProps={{
          sx: {
            "& tr td": {
              borderWidth: "1px",
              borderColor: "divider",
              borderStyle: "solid",
            },
          },
        }}
        renderRowActions={({ row }) => (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            {showPreview && deleteFunction && (
              <Tooltip arrow placement="right" title="Delete">
                <IconButton
                  color="error"
                  onClick={() => deleteFunction(row?.original)}
                >
                  <FiTrash className="w-5" />
                </IconButton>
              </Tooltip>
            )}

            {showPreview && upDatefunction && (
              <Tooltip arrow placement="right" title="Update">
                <IconButton onClick={() => upDatefunction(row?.original)}>
                  <CiEdit />
                </IconButton>
              </Tooltip>
            )}
            {showPreview && routeLink && (
              <Tooltip arrow placement="right" title="View">
                <Link to={`/${routeLink}/${row?.id}`}>
                  <IconButton>
                    <FiEye className="w-5" />
                  </IconButton>
                </Link>
              </Tooltip>
            )}
          </Box>
        )}
      />
    </>
  );
};

export default Table;
